import ApiService from "../../commons/services/ApiService";
import CompanyAPI from "../company/CompanyAPI";

const apiService = new ApiService();
const companyAPI = new CompanyAPI();

export default class ProductCommissionAPI {

    URI_V1 = "/v1/product-commissions";
    getCompanyId = () => companyAPI.getCompanyManagment().id;


    findSummary = async () => {
        return await apiService.get(
            `${this.URI_V1}/summary?companyId=${this.getCompanyId()}`
        );
    };


    payCommission = async (data: any) => {
        return await apiService.post(
            `${this.URI_V1}/payment?companyId=${this.getCompanyId()}`, data
        );
    };

    findPaymentHistory(employeeId: any) {
        return apiService.get(`${this.URI_V1}/${employeeId}/payments?companyId=${this.getCompanyId()}`);
    }

    findPaymentDetail(paymentId: any) {
        return apiService.get(`${this.URI_V1}/payments/${paymentId}?companyId=${this.getCompanyId()}`);
    }

    cancelPayment(paymentId: any) {
        return apiService.delete(`${this.URI_V1}/payments/${paymentId}`);
    }

}